import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import TalcumClaimsWrapper from "@components/layouts/talcumclaimsWrapper";

export default function TalcumClaimsHome(): ReactElement {
    return (
        <TalcumClaimsWrapper>
            <div className="max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="TalcumClaims"
                    domain="TalcumClaims.com"
                />
            </div>
        </TalcumClaimsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
